<template>
  <ul class="nav nav-tab mb-5">
    <li class="nav-item ml-0 pl-0" :class="{active: tab=='campaign'}">
      <router-link :to="'/campaign'" class="nav-link" >
        Campaigns
      </router-link>
    </li>
    <li class="nav-item" :class="{active: tab=='create'}">
      <router-link :to="'/campaign/create'" class="nav-link" >
        Create Campaign
      </router-link>
    </li>
    <li v-if="edit==true" class="nav-item" :class="{active: tab=='edit'}">
      <router-link class="nav-link"  :to="'/campaign/' + id">
        Edit Campaign
      </router-link>
    </li>
  </ul>
</template>

<script>
    export default {
        name: "NavCampaign",
        props: [
            'tab', 'edit', 'id'
        ]
    }
</script>

<style scoped lang="scss">

</style>